// extracted by mini-css-extract-plugin
export default {"center":"Unsubscriptions-center__7kMH6"};